<script setup>
import {useChatStore} from "@/stores/chat.js";
import Button from "@/components/Button/index.vue";
import {Icon} from "@iconify/vue";

const chatStore = useChatStore();
const props = defineProps({
  message: {
    type: Object
  },
});
const emit = defineEmits(['openOrderSummary'])

function extractTextWithLinks(text) {
  const urlRegex = /(https?:\/\/[^\s]+)/g; // Match all links
  const parts = text.split(urlRegex); // Split text by links

  return parts.map((part) => ({
    type: urlRegex.test(part) ? "link" : "text",
    value: part,
  }));
}
function viewOrder(message){
  emit('openOrderSummary', message)
}
</script>

<template>
  <div v-if="message.orderLink">
    <div
        class="flex flex-col gap-3 divide-y divide-slate-500 rounded-2xl bg-blue-500/10 text-slate-300 p-3">
      <p>{{ message.orderType }} Order - {{ message.orderGame }}</p>
      <div class="pt-3 flex flex-col gap-3">
        <p>{{ message.orderTitle }}</p>
        <div>
          <p v-if="message.orderID" class="text-sm text-slate-400">#{{ message.orderID }}</p>
          <p class="text-sm text-slate-400">{{ message.orderType }} - {{ message.orderGame }}</p>
        </div>
        <p>{{ message.orderPrice }} USD</p>
        <div class="grid grid-cols-2 gap-3 w-full justify-between">
          <button @click="viewOrder(message)" class="btn btn-outline-light text-sm font-normal text-slate-500 py-2 rounded-lg">View Order</button>
          <a v-if="message.orderLink" :href="message.orderLink" target="_blank" class="btn btn-outline-light text-sm font-normal py-2 rounded-lg flex flex-row gap-2 items-center justify-center">
            <Icon icon="heroicons:link" />open G2G</a>
        </div>
      </div>
    </div>
  </div>
  <div v-else
       class="flex flex-col gap-3 divide-y divide-slate-500 rounded-2xl bg-blue-500/10 text-slate-300 p-3">
    <p>{{ message.orderType }} Order - {{ message.orderGame }}</p>
    <div class="pt-3 flex flex-col gap-3">
      <p>{{ message.orderTitle }}</p>
      <div>
        <p v-if="message.orderID" class="text-sm text-slate-400">#{{ message.orderID }}</p>
        <p class="text-sm text-slate-400">{{ message.orderType }} - {{ message.orderGame }}</p>
      </div>
      <p>{{ message.orderPrice }} USD</p>
      <div
          class="text-contrent dark:text-slate-300 text-sm font-normal rounded-2xl flex-1 whitespace-pre-wrap break-all">
        <p style="word-break: break-word">
          <template v-for="(part, partIndex) in extractTextWithLinks(message.message)" :key="partIndex">
            <template v-if="part.type === 'text'">{{ part.value }}</template>
            <a v-else :href="part.value" target="_blank" class="underline"
               :class="chatStore.chatData.contact === message.from ? 'text-success-600' : 'text-blue-400'">
              {{ part.value }}
            </a>
          </template>
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>